import http from "../../http";

/** 人员标签配置 — /resident/api/resident/housePersonTag */
const BASE = "/resident/api/resident/housePersonTag";

const personTag = {
  selectPage(r) {
    return http.get(`${BASE}/page`, r);
  },
  selectList(r) {
    return http.get(`${BASE}/list`, r);
  },
  selectById(r) {
    return http.get(`${BASE}/detail`, r);
  },
  save(r) {
    return http.payload(`${BASE}/save`, r);
  },
  updateStatus(r) {
    return http.tip.post(`${BASE}/updateStatus`, r);
  },
  updateSortNo(r) {
    return http.tip.post(`${BASE}/updateSortNo`, r);
  },
  delete(r) {
    return http.confirm.post(`${BASE}/delete`, r);
  },
};

export default personTag;
